import { queryOptions, useMutation, useQuery } from "@tanstack/react-query";
import { message } from "antd";
import { get } from "lodash";
import { apiBase } from "../utils/apiBase";
import { queryClient, REFERENCE_QUERY_OPTIONS } from "./queryClient";

export const labelsQuery = queryOptions({
  queryKey: ["labels"],
  queryFn: () =>
    apiBase.get("labels").then((res) => get(res, "data.labels", [])),
  ...REFERENCE_QUERY_OPTIONS,
  meta: { errorMessage: "Failed to load labels." },
});

export const useLabels = () => useQuery(labelsQuery);

// POST returns the fresh list, so write it straight into the cache (no extra
// round-trip) — this is the invalidation for the long-lived ["labels"] query.
export const useUpdateLabels = () =>
  useMutation({
    mutationFn: (data) =>
      apiBase.post("labels", data).then((res) => get(res, "data.labels", [])),
    onSuccess: (labels) => {
      queryClient.setQueryData(labelsQuery.queryKey, labels);
    },
    onError: () => {
      message.error("Failed to update labels.");
    },
  });
